function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  rx: 256,
  fill: "#090E11",
  fillOpacity: 0.59
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M142.611 280.611L256 394L369.389 280.611",
  stroke: "white",
  strokeWidth: 25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M256 394V119",
  stroke: "white",
  strokeWidth: 25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcDownloadChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadChat);
export default __webpack_public_path__ + "static/media/ic_download_chat.75185006cf7ec130cc6d19a2bd5c8b8e.svg";
export { ForwardRef as ReactComponent };